/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetCampaignStatsQueryResponse,
  GetCampaignStatsQueryParams,
} from '../types/GetCampaignStats'

function getGetCampaignStatsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/contacts/campaigns/stats/` as const,
  }
  return res
}

/**
 * @description Return aggregate campaign stats for the current user's company.
 * @summary Get aggregate campaign stats
 * {@link /api/v1/contacts/campaigns/stats/}
 */
export async function getCampaignStats(
  params?: GetCampaignStatsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetCampaignStatsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetCampaignStatsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
